import images from '../../assets/images';
import { MeetingCategoryType } from '../../pages/AdminPta/AdminPta';
import { getScreenDimensions } from '../../utils/helper';
import './PtaHeader.scss';


interface PropsType {
  title: string;
  subtitle: string;
  addLabel: string;
  handleSearchDebounce?: any;
  subImage: any;
  searchValue: string;
  setSearchValue: (value: string) => void;
  setShowCreateScheduling?: (value: boolean) => void;
  handleBack: () => void;
  isShowBackArrow: boolean;
  setEditClicked?: (val: boolean) => void; 
  selectedCategory: MeetingCategoryType | undefined;
  showCreateScheduling: boolean;
}
const PtaHeader = ({ title, subtitle, addLabel, handleSearchDebounce, subImage, searchValue, setSearchValue, setShowCreateScheduling, handleBack, isShowBackArrow, setEditClicked, selectedCategory, showCreateScheduling }: PropsType) => {
  const { backArrow, backArrowWhite, plusIcon } = images;
  const { isMobileScreen } = getScreenDimensions();

  const searchOnChange = (event: { target: { value: string }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounce){
      handleSearchDebounce(event?.target?.value, selectedCategory);
    }
  }

  const handleClick = () => {
    if (setShowCreateScheduling) {
      setShowCreateScheduling(true);
    }
    if (setEditClicked) {
      setEditClicked(false);
    }
  }

  return (
    <div className='PtaTabsContentHeader'>
      <div className={subImage === backArrow? 'tabsHeaderLeftContainerBack' : 'tabsHeaderLeftContainer'}>
        {(isShowBackArrow) ? (
          <div className={subImage === backArrow ? 'backImageContainer' : subImage === backArrowWhite ? 'backArrowWhite' :'imageContainer'} onClick={handleBack}>
            <img src={subImage} alt='userImage' className={`imageStyle ${(subImage === backArrowWhite)&& 'imageSize'}`} />
          </div>
        ) : <div className='backImageContainer hideCursor' />}
        {(subtitle !== "" || (showCreateScheduling && isMobileScreen)) && (
          <div className={`labelContainer ${(showCreateScheduling && isMobileScreen) ? "mobileLabelContainer" : ""}`}>
            <div className={`titleStyle ${(showCreateScheduling && isMobileScreen) ? "mobileTitle" : ""}`}>{title}</div>
            <div className='subTitleStyle'>{subtitle}</div>
          </div>
        )}
      </div>
      {(subtitle !== "") && (
        <div className='tabHeaderMiddleContainer'>
          <input id="searchBox" type='text' onChange={searchOnChange} value={searchValue} placeholder='Search' className='searchInputFieldStylePta' />
        </div>
      )}
      {(addLabel==="" && !setShowCreateScheduling) && <div className='tabHeaderRightContainerEmpty' />}
      {(setShowCreateScheduling && subImage !== backArrow) && (
        <div className='tabHeaderRightContainer' onClick={handleClick}>
          <div className='BtnContainer'>{isMobileScreen ? <img src={plusIcon} />  : "Schedule meeting"}</div>
        </div>
      )}
    </div>
  )
}

export default PtaHeader;
